// AUTHOR: NANDHAKUMAR
// VERSION: 0.0.1
// LAST EDIT: NANDHAKUMAR
// DATE: 17/09/2025
// DESCRIPTION: QR REPORT PAGE SAGA
import { takeLatest, put, all, call } from 'redux-saga/effects';
import QrReportActionTypes from './qr-report.types';
import { fetchQrReport } from './qr-report.services';
import {
	fetchQrReportSuccess,
	fetchQrReportFailure,
	fetchQrReportResponseChanged,
} from './qr-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** ***************** GET QR REPORT DETAILS START *********************** */
export function* fetchQrReportDetails({ payload }: any) {
	try {
		const key = 'QRPaymentReportKey';
		const { companyID, branchID, centerID, databaseName, fromDate, toDate, limit, loanType } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			Limit: limit,
			LoanIndexType: loanType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchQrReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchQrReportFailure(responseData.data));
		} else {
			yield put(fetchQrReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchQrReportFailure(error));
	}
}

export function* resetFetchMRRReportResponse() {
	yield put(fetchQrReportResponseChanged());
}

export function* onFetchQrReport() {
	yield takeLatest(QrReportActionTypes.FETCH_QR_REPORT_START, fetchQrReportDetails);
}

export function* onFetchQrReportResponseReset() {
	yield takeLatest(
		QrReportActionTypes.FETCH_QR_REPORT_RESPONSE_RESET,
		resetFetchMRRReportResponse,
	);
}
/** ***************** GET QR REPORT DETAILS START *********************** */
export function* qrReportSaga() {
	yield all([call(onFetchQrReport), call(onFetchQrReportResponseReset)]);
}
